import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg';
import { FormsModule } from '@angular/forms';

import { HotelService } from '../../api/services/hotel.service';
import { WriteReviewComponent } from './write-review/';
import { ComponentsModule } from '../../components';

const routes: Routes = [
  { path: '', component: WriteReviewComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    // InlineSVGModule.forRoot({ baseUrl: '/resources/global/stay-mgmt/assets/svg/' })
    InlineSVGModule.forRoot({baseUrl: `/resources/global/stay-mgmt/v12.0.0/assets/svg/`})
  ],
  declarations: [
    WriteReviewComponent
  ],
  exports: [
    RouterModule,
    WriteReviewComponent
  ],
  providers: [
    HotelService
  ]
})
export class WriteReviewModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/write-review/write-review.module.ts